import { Price, Quantity } from 'types'
import { numberToString } from 'utils/number'
import { OrderbookDataItem } from '../../store/orderbook/types'

export const formatOrderbookMessage = (
  arr: [Price, Quantity][],
  animationFlag = false,
): OrderbookDataItem[] => {
  if (!arr?.length) return []

  return arr.map((item) => ({
    price: numberToString(item[0]),
    amount: numberToString(item[1]),
    animationFlag,
  }))
}

export const binanceKLineArrayToObject = (arr: any) => {
  if (!arr?.length) {
    return []
  }
  return arr.map((item: any) => ({
    time: item.t,
    low: item.l,
    high: item.h,
    open: item.o,
    close: item.c,
    volume: item.v,
  }))
}

export const arrContactAndRemoveRepetition = (arr1: any, arr2: any) => {
  const arr = [...arr1, ...arr2]
  const map = new Map()
  for (let item of arr) {
    if (!map.has(item.id)) {
      map.set(item.id, item)
    }
  }
  return [...map.values()]
}
